var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.965 8.655 15.983 1 3 8.655v14.948L15.983 31l12.983-7.397V8.655zM15.828 4.621l-9.673 5.587v11.638L8.07 22.96V11.448L15.982 7l7.707 4.707v8.741l-6.26 3.62 2.18 1.278 6.2-3.501V10.207L15.828 4.62zm2.18 21.632-8.232-5.183v2.885l6.052 3.528 2.18-1.231zM9.723 12.276l6.104-3.466 6.258 3.466v7.345l-6.258 3.621-6.104-3.62v-7.344zm2.173 6 3.93 2.276 4.087-2.276v-4.5l-4.086-2.328-3.931 2.328v4.5z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamp);
export default __webpack_public_path__ + "static/media/RAMP.4ade352fefbf546961b840c0dc5fa12c.svg";
export { ForwardRef as ReactComponent };